import { useLayoutEffect, type FC } from 'react';

export const HelpAnnotationsDebugStyle: FC<{
  helpAnnotations: string[];
}> = ({ helpAnnotations }) => {
  useLayoutEffect(() => {
    helpAnnotations.forEach((annotation) => {
      const elements = document.querySelectorAll(
        `[data-annotation="${annotation}"]`
      );
      elements.forEach((element) => {
        if (element instanceof HTMLElement) {
          element.style.display = 'flex';
        }
      });
    });

    return () => {
      helpAnnotations.forEach((annotation) => {
        const elements = document.querySelectorAll(
          `[data-annotation="${annotation}"]`
        );
        elements.forEach((element) => {
          if (element instanceof HTMLElement) {
            element.style.display = 'none';
          }
        });
      });
    };
  }, [helpAnnotations]);
  return null;
};
